import React from "react";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../../../animation/motionAnimation";

const NewScroolSticky = ({ title, image, i, para }) => {
  return (
    <div className={`flex ${i % 2 === 0 ? "flex-row-reverse" : "flex-row"}`}>
      <div className="w-1/2 p-10 ">
        <img src={image} className="w-full h-full object-cover object-center rounded-xl" />
      </div>
      <div className="w-1/2 p-4 flex flex-col justify-center">
        <motion.h2
          {...fadeInAnimation}
          className="text-3xl font-semibold uppercase my-4 text-g-black"
        >
          {title}
        </motion.h2>
        <p className="text-xl  text-mute-grey">{para}</p>
      </div>
    </div>
  );
};

export default NewScroolSticky;
